export const APP_NAME = {
  en: 'Personal Finance: PCM Planning, Controlling & Monitoring',
  es: 'Finanzas Personales: PCM Planificación, Control y Monitoreo',
  pt: 'Finanças Pessoais: PCM Planejamento, Controle e Monitoramento',
  fr: 'Finance Personnelle: PCM Planification, Contrôle et Suivi',
};

export const APP_DESCRIPTION = {
  en: 'A comprehensive personal finance management system with Planning, Controlling, and Monitoring capabilities.',
  es: 'Un sistema completo de gestión de finanzas personales con capacidades de Planificación, Control y Monitoreo.',
  pt: 'Um sistema completo de gestão de finanças pessoais com capacidades de Planejamento, Controle e Monitoramento.',
  fr: 'Un système complet de gestion des finances personnelles avec des capacités de Planification, Contrôle et Suivi.',
};

export const APP_VERSION = '1.0.0';
export const APP_YEAR = new Date().getFullYear();
